var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4062 4.9375L13.0625 2.59375C12.6875 2.21875 12.1875 2 11.6562 2H6C4.875 2 4 2.90625 4 4V16C4 17.125 4.875 18 6 18H14C15.0938 18 16 17.125 16 16V6.34375C16 5.8125 15.7812 5.3125 15.4062 4.9375ZM14.5 16C14.5 16.2813 14.25 16.5 14 16.5H6C5.71875 16.5 5.5 16.2813 5.5 16V4.03125C5.5 3.75 5.71875 3.53125 6 3.53125H11V6C11 6.5625 11.4375 7 12 7H14.4688V16H14.5ZM7 10.75C7 11.1875 7.3125 11.5 7.75 11.5H12.25C12.6562 11.5 13 11.1875 13 10.75C13 10.3438 12.6562 9.99999 12.25 9.99999H7.75C7.3125 9.99999 7 10.3438 7 10.75ZM12.25 13H7.75C7.3125 13 7 13.3438 7 13.75C7 14.1875 7.3125 14.5 7.75 14.5H12.25C12.6562 14.5 13 14.1875 13 13.75C13 13.3438 12.6562 13 12.25 13Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage);
export default __webpack_public_path__ + "static/media/page.9a81fc99206c7a8c7ecbe83ddb27a5ff.svg";
export { ForwardRef as ReactComponent };